import moment from "moment";
import Loading from "../Base/Loading";
import { Avatar, Divider } from "reakit";
import React, { Component } from "react";
import { Box, Card, Flex, Text } from "rebass";

const textProps = {
  fontSize: "16px",
  fontWeight: 600,
  ml: "7px",
  textAlign: "left",
};

const symptoms = [
  "Fever or chills",
  "Cough",
  "Shortness of breath or difficulty breathing",
  "Fatigue",
  "Muscle or body aches",
  "Headache",
  "New loss of taste or smell",
  "Sore throat",
  "Congestion or runny nose",
  "Nausea or vomiting",
  "Diarrhea"
  ]

class HealthAdminDetails extends Component {
  state = {
    loading: false,
    sick: false,
    symptomInfo: symptoms.map(function(symptom) {
      return {value: symptom, isChecked: false}
    }),
    isUpdate: false,
    edited: false,
  };

  componentDidMount() {
    const { selectedHealthData } = this.props;
    if (selectedHealthData) {
      this.setState({
        sick: selectedHealthData.sick,
        isUpdate: true,
      });
      // selectedHealthData symptomInfo is array
      let symptomInfo = this.state.symptomInfo
      symptomInfo.forEach((symptom) => {
        if (selectedHealthData.symptomInfo.includes(symptom.value)) {
          symptom.isChecked = true
        }
      })
      this.setState({ symptomInfo: symptomInfo })
    } else {
      this.setState({
        sick: false,
        symptomInfo: symptoms.map(function(symptom) {
          return {value: symptom, isChecked: false}
        }),
        isUpdate: false,
      });
    }
  }

  componentWillUnmount() {
    // update or create new ref
    const { sick, symptomInfo, isUpdate, edited } = this.state;
    const {
      selected,
      selectedHealthData,
      selectedHealthDataRef,
      selectedIsStudent,
      date,
    } = this.props;

    // Construct symptomInfo array
    let symptomsInfoArray = []
    symptomInfo.forEach((info) => info.isChecked ? symptomsInfoArray.push(info.value) : null)

    if (isUpdate) {
      if (edited) {
        selectedHealthDataRef.update({
          sick: sick,
          symptomInfo: symptomsInfoArray,
        });
        // Only update if the selected health data is the most recent entry
        if (selectedHealthData.post_time >= selected.health_last_updated) {
          if (selectedIsStudent) {
            this.props.firebase.student(selected.id).update({
              healthy: !(sick),
            });
          } else {
            this.props.firebase.faculty(selected.id).update({
              healthy: !(sick),
            });
          }
        }
      }
    } else {
      if (edited) {
        let submissionTime = date.getTime() / 1000;

        let ref = null;
        if (selectedIsStudent) {
          ref = this.props.firebase.student(selected.id);
        } else {
          ref = this.props.firebase.faculty(selected.id);
        }

        let healthRef = ref.collection("health_history");
        let newHealth = healthRef.doc();

        newHealth.set({
          sick: sick,
          symptomInfo: symptomsInfoArray,
          post_time: submissionTime,
        });

        if (
          submissionTime >= selected.health_last_updated ||
          selected.health_last_updated === undefined
        ) {
          if (selectedIsStudent) {
            this.props.firebase.student(selected.id).update({
              healthy: !(sick),
              health_last_updated: submissionTime,
            });
          } else {
            this.props.firebase.faculty(selected.id).update({
              healthy: !(sick),
              health_last_updated: submissionTime,
            });
          }
        }
      }
    }
  }

  handleCheckbox = (event) => {
    const target = event.target;
    const value = target.checked;
    const name = target.name;

    this.setState({
      [name]: value,
      edited: true,
    });
  };

  handleCheckSymptom = (event) => {
    const target = event.target;
    const value = target.checked;
    const name = target.name;
    let symptomInfo = this.state.symptomInfo
    symptomInfo.forEach((symptom) => {
      if (symptom.value === name) {
        symptom.isChecked = value
      }
    })
    this.setState({ symptomInfo: symptomInfo, edited: true })

    if (value && !this.state.sick) {
      this.setState({ sick: true })
    }
  }

  render() {
    const {
      loading,
      sick,
      symptomInfo,
      isUpdate,
      edited,
    } = this.state;
    const { selected, selectedHealthData, historyView } = this.props;

    let submissionTime = "";
    let selectedIsHealthy = null;

    if (selectedHealthData) {
      submissionTime = moment
        .unix(selectedHealthData.post_time)
        .format("MMM DD     hh:mm A");
    } else {
      submissionTime = "N/A";
    }


    if (isUpdate || edited) {
      if (sick) {
        selectedIsHealthy = false;
      } else {
        selectedIsHealthy = true;
      }
    } else {
      selectedIsHealthy = undefined;
    }

    return (
      <Box py={loading ? "40px" : "auto"}>
        {loading ? (
          <Loading />
        ) : (
          <Card boxShadow={"main"} p={3}>
            {selected && (
              <Flex flexWrap={"wrap"} mt={0} p={0}>
                {historyView ? null : (
                  <div>
                    <Box width={1}>
                      <Flex width={1} p={0}>
                        <Text
                          marginTop="20px"
                          fontWeight={900}
                          fontSize={"21px"}
                        >
                          {selected.first_name} {selected.last_name}
                        </Text>

                        <Box ml={"auto"} />
                        <Box>
                          <Avatar
                            src={selected.profile_pic}
                            palette={"greys"}
                            opaque
                            tone={0}
                            fontSize={50}
                          />
                        </Box>
                      </Flex>
                    </Box>

                    <Box width={1} py={1}>
                      <Divider padding={0} margin={0} />
                    </Box>
                  </div>
                )}

                <Flex width={1} py={3}>
                  {selectedIsHealthy === undefined ? (
                    <Text
                      color="#AB80B9"
                      marginTop="7px"
                      {...textProps}
                      fontWeight={800}
                    >
                      UNSUBMITTED
                    </Text>
                  ) : selectedIsHealthy ? (
                    <Text
                      color="#2BB99E"
                      marginTop="7px"
                      {...textProps}
                      fontWeight={800}
                    >
                      HEALTHY
                    </Text>
                  ) : (
                    <Text
                      color="#F95050"
                      marginTop="7px"
                      {...textProps}
                      fontWeight={800}
                    >
                      UNHEALTHY
                    </Text>
                  )}
                </Flex>

                <Flex width={1} py={3}>
                  <Text marginTop="-10px" {...textProps}>
                    Submission Time: {submissionTime}
                  </Text>
                </Flex>

                <Box width={1}>
                  <Divider margin={0} padding={0} />
                </Box>
                  

                {/* 
                <Box pl={3}>
                <Text py={3} fontSize={"16px"} fontWeight={600}>
                  <input
                    style={{ marginRight: "0.5em" }}
                    name={"around"}
                    type="checkbox"
                    checked={around}
                    onChange={this.handleCheckbox}
                  />
                  Have you been around someone who is sick?
                </Text>
              </Box>

              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>

              <Box pl={3}>
                <Text py={3} fontSize={"16px"} fontWeight={600}>
                  <input
                    style={{ marginRight: "0.5em" }}
                    name={"exposed"}
                    type="checkbox"
                    checked={exposed}
                    onChange={this.handleCheckbox}
                  />
                  Have you been exposed in the last three days to someone who has COVID-19 or COVID-like symptoms?
                </Text>
              </Box>
                */}

              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>

              <Box pl={3}>
                <Text py={3} fontSize={"16px"} fontWeight={600}>
                  <input
                    style={{ marginRight: "0.5em" }}
                    name={"sick"}
                    type="checkbox"
                    checked={sick}
                    onChange={this.handleCheckbox}
                  />
                  Are you feeling sick?
                </Text>
              </Box>

              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>

              <Box pl={3}>
                <Text py={3} fontSize={"16px"} fontWeight={600}>
                  If sick, check any symptoms you have:
                </Text>
                {symptomInfo.map((symptom) => {
                  return <div>
                    <input
                    style={{ marginRight: "0.5em" }}
                    name={symptom.value}
                    type="checkbox"
                    checked={symptom.isChecked}
                    onChange={this.handleCheckSymptom}
                    />
                    <>{symptom.value}</>
                  </div>
                })}
                <br />
              </Box>

              <Box width={1}>
                <Divider margin={0} padding={0} />
              </Box>
              </Flex>
            )}
          </Card>
        )}
      </Box>
    );
  }
}

export default HealthAdminDetails;
